import { useGlobalStore } from '../../../Common/store';
import bindActions from '../../../Common/actions';
import trustPickerReducer from '../../store/trustPicker';

const { actions } = trustPickerReducer;

/**
 * useTrustPicker Custom Hook
 */
const useTrustPicker: any = () => {
	const { state , dispatch } = useGlobalStore();

	// List of Props
	const { trustPicker } = state;

	// List of Actions
	const {
		handleReturnCustomerCodes 
	} = actions;

	// Bind Actions
	const trustPickerActions = bindActions({
		handleReturnCustomerCodes 
	}, dispatch);

	return { trustPicker, ...trustPickerActions };
}

export default useTrustPicker;
